import { StockInputValue_New_Option } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { stockDataUtil } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/util.ts';
import { Html, html } from 'rune-ts';
import klass from './Input_Stock.module.scss';
import {
  ALL_CHECK_NAME,
  Base_Input_Stock,
  CHECK_BOX_KLASS,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Base_Input_Stock.ts';
import { ButtonCheckbox } from '@services/MarppleShop/renderApp/components/atoms/ButtonCheckbox/ButtonCheckbox.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { StudioButton } from '@services/MarppleShop/shared/components/atoms/StudioButton/StudioButton.ts';

interface InputStock_New_Option extends InputEditor {
  mode: typeof MODE.NEW;
  stock_type: typeof StockType.OPTION_STOCK;
  value: StockInputValue_New_Option[];
}

export class Input_Stock_New_Option extends Base_Input_Stock<InputStock_New_Option> {
  private readonly deleteButton = new StudioButton({
    custom_klass: `${klass.delete_button}`,
    label: '삭제',
    color: 'line_gray',
    size: 'free',
  });

  protected inputTemplate() {
    return html`
      <div class="${klass.stock_table} ${klass.new_option} ${font('14_medium')}">
        <div class="${klass.row} ${klass.header}">
          <div class="${klass.col}">
            ${new ButtonCheckbox({
              name: ALL_CHECK_NAME,
              active: false,
              klass: CHECK_BOX_KLASS,
            })}
          </div>
          <div class="${klass.col}">품목</div>
          <div class="${klass.col}">추가 금액</div>
          <div class="${klass.col}">재고</div>
          <div class="${klass.col}">재고관리 번호</div>
        </div>
        ${this.data.value.map((item, index) => {
          return html`
            <div class="${klass.row}">
              <div class="${klass.col}">
                ${new ButtonCheckbox({
                  name: `checkbox__${index}`,
                  active: false,
                  klass: CHECK_BOX_KLASS,
                  index,
                })}
              </div>
              <div class="${klass.col}">${item.name}</div>
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.price,
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'price');
                  },
                })}
              </div>
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.stock,
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'stock');
                  },
                })}
              </div>
              <div class="${klass.col}">
                ${stockDataUtil.textInput({
                  index,
                  name: this.data.name,
                  value: item.sku,
                  placeholder: 'SKU',
                  onFocusout: (view) => {
                    this.onStringOptionChange(view, 'sku');
                  },
                })}
              </div>
            </div>
          `;
        })}
      </div>
    `;
  }

  override titleRightHtml(): Html {
    return html`<div class="${klass.button_wrap} ${klass.hidden}">${this.deleteButton}</div>`;
  }
}
